import React, { useEffect, useRef, useState } from "react";
import { Outlet, Navigate, Link, useOutletContext } from "react-router-dom";
import useToken from "../components/helpers/useToken";
import MainNavItem from "../components/shared/MainNavItem";
import apiClient from "../components/utils/apiClient";
import useUser from "../components/helpers/useUser";
import useError403 from "../components/Toast/useError403";

const AppLayout = ({ children }) => {

  useError403();

  const [token, setToken] = useToken();
  const [navState, setNavState] = useState(true);
  const [propertyTypes, setPropertyTypes] = useState([]);
  const [user,setUser] = useUser();


  if(user && !user?.business) {
    window.localStorage.removeItem('token');
    window.localStorage.removeItem('b-user');
    window.location.href = '/ar/login';
  }

  const getPropertyResidentialTypes = async () => {
    try {
      const response = await apiClient.get(`/b-properties/types?category=residential`);
      if(response?.data) {
        const newPropertyTypes = {};
        newPropertyTypes.residential = response?.data;
        setPropertyTypes(newPropertyTypes);
      } else {
      }
    } catch(err) {}
  }
  const getPropertyCommercialTypes = async () => {
    try {
      const response = await apiClient.get(`/b-properties/types?category=commercial`);
      if(response?.data) {
        const newPropertyTypes = propertyTypes;
        newPropertyTypes.commercial = response?.data;
        setPropertyTypes(newPropertyTypes);
      } else {
      }
    } catch(err) {}
  }

  useEffect(()=>{
    if(token) {
      getPropertyResidentialTypes();
    }
  },[token])

  useEffect(()=>{
    if(propertyTypes && propertyTypes?.residential && !propertyTypes?.commercial) {
      getPropertyCommercialTypes();
    }
  },[propertyTypes])

  const usersSubMenu = [
    {label:'المستخدمين', icon:'user-square-menu.svg', link:'/ar/users'},
    {label:'المستفيدين', icon:'tag-user.svg', link:'/ar/beneficiaries'},
  ]

  const inventorySubMenu = [
    {label:'الأصول', icon:'assets-icon.svg', link:'/ar/assets'},
    {label:'المخزون', icon:'inventory-icon.svg', link:'/ar/inventory'},
  ]

  const RequestsSubMenu = [
    {label:'طلبات الصيانة', icon:'mini-requset.svg', link:'/ar/requests'},
    {label:'الصيانة الوقائية', icon:'mini-prev.svg', link:'/ar/preventive-visits'},
  ];

  const MarketplaceSubMenu = [
    {label:'المتاجر', icon:'mini-marketplace.svg', link:'/ar/marketplace'},
    {label:'الطلبات', icon:'mini-orders.svg', link:'/ar/orders'},
  ];

  const [submenuHover, setSubmenuHover] = useState(false);
  const [submenuPosition, setSubmenuPosition] = useState(null);

  
  const handleMouseEnter = (submenuName) => {
        setSubmenuHover(submenuName);
  };

  const handleMouseLeave = () => {
    setSubmenuHover(false);
  };


  return (
    token ? 
    <div className="app-layout flex overflow-y-hidden h-screen w-screen">
      <div className={`w-[24px] h-[24px] cursor-pointer absolute top-[25px] z-[30] transition-all ${navState ? 'rotate-0 start-[217px]' : 'rotate-180 start-[99px]'}`} style={{background:"url('/assets/images/arrow-circle-right.svg')"}} onClick={()=>setNavState(!navState)}></div>
      { submenuHover && submenuHover === 'users' && <ul className="submenuHover absolute z-[999] bg-darkBlue w-[60px]" style={{top:(submenuPosition?.y + 10)+'px',left:(submenuPosition?.x - 60)+'px'}}
        onMouseEnter={()=>handleMouseEnter('users')}
        onMouseLeave={handleMouseLeave}
        onClick={handleMouseLeave}>
        {usersSubMenu.map((subMenuItem,index)=>{
                    return(<li key={'submenu-users-'+index} className={`relative group`}>
                            <Link to={subMenuItem.link} className={`block relative py-[8px]`}>
                                <span className={`w-[40px] h-[40px] bg-center bg-no-repeat inline-block align-middle ms-[10px] me-[10px] transition-all opacity-50 group-hover:opacity-100`} style={{backgroundImage:"url('/assets/images/"+subMenuItem.icon+"')", backgroundSize: 'contain'}}></span>
                            </Link>
                        </li>)
                })}
      </ul>}
      { submenuHover && submenuHover === 'inventory' && <ul className="submenuHover absolute z-[999] bg-darkBlue w-[60px]" style={{top:(submenuPosition?.y + 10)+'px',left:(submenuPosition?.x - 60)+'px'}}
        onMouseEnter={()=>handleMouseEnter('inventory')}
        onMouseLeave={handleMouseLeave}
        onClick={handleMouseLeave}>
        {inventorySubMenu.map((subMenuItem,index)=>{
                    return(<li key={'submenu-inventory-'+index} className={`relative group`}>
                            <Link to={subMenuItem.link} className={`block relative py-[8px]`}>
                                <span className={`w-[40px] h-[40px] bg-center bg-no-repeat inline-block align-middle ms-[10px] me-[10px] transition-all opacity-50 group-hover:opacity-100`} style={{backgroundImage:"url('/assets/images/"+subMenuItem.icon+"')", backgroundSize: 'contain'}}></span>
                            </Link>
                        </li>)
                })}
      </ul>}
      { submenuHover && submenuHover === 'requests' && <ul className="submenuHover absolute z-[999] bg-darkBlue w-[60px]" style={{top:(submenuPosition?.y + 10)+'px',left:(submenuPosition?.x - 60)+'px'}}
        onMouseEnter={()=>handleMouseEnter('requests')}
        onMouseLeave={handleMouseLeave}
        onClick={handleMouseLeave}>
        {RequestsSubMenu.map((subMenuItem,index)=>{
                    return(<li key={'submenu-requests-'+index} className={`relative group`}>
                            <Link to={subMenuItem.link} className={`block relative py-[8px]`}>
                                <span className={`w-[40px] h-[40px] bg-center bg-no-repeat inline-block align-middle ms-[10px] me-[10px] transition-all opacity-50 group-hover:opacity-100`} style={{backgroundImage:"url('/assets/images/"+subMenuItem.icon+"')", backgroundSize: 'contain'}}></span>
                            </Link>
                        </li>)
                })}
      </ul>}
      { submenuHover && submenuHover === 'marketplace' && <ul className="submenuHover absolute z-[999] bg-darkBlue w-[60px]" style={{top:(submenuPosition?.y + 10)+'px',left:(submenuPosition?.x - 60)+'px'}}
        onMouseEnter={()=>handleMouseEnter('marketplace')}
        onMouseLeave={handleMouseLeave}
        onClick={handleMouseLeave}>
        {MarketplaceSubMenu.map((subMenuItem,index)=>{
                    return(<li key={'submenu-marketplace-'+index} className={`relative group`}>
                            <Link to={subMenuItem.link} className={`block relative py-[8px]`}>
                                <span className={`w-[40px] h-[40px] bg-center bg-no-repeat inline-block align-middle ms-[10px] me-[10px] transition-all opacity-50 group-hover:opacity-100`} style={{backgroundImage:"url('/assets/images/"+subMenuItem.icon+"')", backgroundSize: 'contain'}}></span>
                            </Link>
                        </li>)
                })}
      </ul>}
      <div className={`translate-x-full lg:-translate-x-0 fixed z-[21] flex flex-col flex-shrink-0 w-[229px] max-h-screen transition-all transform lg:z-auto lg:static ${navState ? 'lg:w-[229px]' : 'lg:w-[111px]'}`}>
        <div className="bg-darkBlue w-full h-screen overflow-y-auto">
          <Link to="/" className={`block bg-center bg-no-repeat h-[47px] mx-auto mt-[35px] ${navState ? 'w-[128px]' : 'w-[54px]'}`} style={{background: navState ? "url('/assets/images/logo-white.svg')" : "url('/assets/images/logo-mini.svg')"}}></Link>
          <nav className="pt-[35px]">
            {navState && <span className="text-[16px] font-[400] leading-[34px] text-grey-400 ps-[20px]">القائمة</span>}
            <ul className="p-0 m-0">
              <MainNavItem navStatus={navState} label={'الرئيسية'} icon={'main-home-icon.svg'} link={'/'} />
              <MainNavItem navStatus={navState} label={'المنشأت'} icon={'main-property-icon.svg'} link={'/ar/property'} />
              <MainNavItem collapse={true} subMenu={RequestsSubMenu} mainRoute={['/requests','preventive-visits']} navStatus={navState} label={'أوامر العمل'} icon={'main-request-icon.svg'} link={'/ar/requests'} setSubmenuPosition={setSubmenuPosition} setSubmenuHover={setSubmenuHover} submenuHover={submenuHover} submenuName={'requests'} />
              <MainNavItem collapse={true} subMenu={usersSubMenu} mainRoute={['users','beneficiaries']} navStatus={navState} label={'إدارة المستخدمين'} icon={'main-user-icon.svg'} link={'/ar/users'} setSubmenuPosition={setSubmenuPosition} setSubmenuHover={setSubmenuHover} submenuHover={submenuHover} submenuName={'users'} />
              <MainNavItem collapse={true} subMenu={inventorySubMenu} mainRoute={['assets','inventory']} navStatus={navState} label={'إدارة الأصول'} icon={'wharehouse-icon.svg'} link={'/ar/assets'} setSubmenuPosition={setSubmenuPosition} setSubmenuHover={setSubmenuHover} submenuHover={submenuHover} submenuName={'inventory'} />
              <MainNavItem navStatus={navState} label={'إدارة المدفوعات'} icon={'receipt-icon.svg'} link={'/ar/payment-requests'} />
              <MainNavItem navStatus={navState} label={'مركز التنبيهات'} icon={'notification-status-icon.svg'} link={'/ar/notifications-center'} />
              <MainNavItem collapse={true} subMenu={MarketplaceSubMenu} mainRoute={['marketplace','orders']} navStatus={navState} label={'المتاجر'} icon={'shop-icon.svg'} link={'/ar/marketplace'} setSubmenuPosition={setSubmenuPosition} setSubmenuHover={setSubmenuHover} submenuHover={submenuHover} submenuName={'marketplace'} />
              <MainNavItem navStatus={navState} label={'التقارير'} icon={'reports-icon.svg'} link={'/ar/reports'} />
              {/* <MainNavItem navStatus={navState} label={'الطلبات'} icon={'main-request-icon.svg'} link={'/ar/requests'} /> */}
              {/* <MainNavItem navStatus={navState} label={'الصيانة الوقائية'} icon={'main-maintenance-icon.svg'} link={'/ar/preventive-visits'} /> */}
            </ul>
            {navState && <span className="text-[16px] font-[400] leading-[34px] text-grey-300 ps-[20px] relative mt-[45px] block"><i className="absolute block w-[100px] h-[1px] top-[-10px] start-[20px] bg-grey-300"></i>المساعدة والدعم</span>}
            <ul className="p-0 m-0">
              <MainNavItem navStatus={navState} label={'مركز المساعدة'} icon={'main-help-icon.svg'} link={'/ar/help'} grey300={true} />
              <MainNavItem navStatus={navState} label={'الإعدادات'} icon={'main-settings-icon.svg'} link={'/ar/settings'} grey300={true} />
              <MainNavItem navStatus={navState} label={'تسجييل الخروج'} icon={'logout.svg'} link={'#!'} grey300={true} disableArrow={true} type={'logout'} />
            </ul>
          </nav>
        </div>
      </div>
      <div className="flex flex-col flex-1 h-full overflow-y-auto">
        <Outlet context={{navState,propertyTypes}}/> 
      </div>
    </div> : <Navigate to="/ar/login"/>
  );
};

export function useAppLatyoutContext() {
  return useOutletContext();
}

export default AppLayout;
